let previousOverflow: string | null = null;

export function setBodyScrollLocked(locked: boolean): void {
  if (locked && previousOverflow === null) {
    previousOverflow = document.body.style.overflowY;
    document.body.style.overflowY = 'hidden';
  } else if (!locked && previousOverflow !== null) {
    document.body.style.overflowY = previousOverflow;
    previousOverflow = null;
  }
}
